<template>
    <zen-message-modal
        :isOpen="isOpen"
        title="Revoke token?"
        icon-variant="danger"
    >
        <p class="text-sm text-taupe-500 mb-4">
            <strong>{{ target?.name }}</strong> will be permanently revoked. Any
            integrations using it will stop working immediately.
        </p>
        <template v-slot:buttons>
            <zen-button variant="secondary" @click="$emit('close')">
                Cancel
            </zen-button>
            <zen-button
                variant="primary-danger"
                :processing="processing"
                processing-label="Revoking…"
                @click="$emit('confirm')"
            >
                Revoke token
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'RevokeApiTokenModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        target: {
            type: Object,
            default: null,
        },
        processing: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'confirm'],
}
</script>
